import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingsWrapper: {},
  headerTooltip: {
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(2),
    },
  },
}));
